import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';

import * as BookerActions from '../../../../redux/actions/booking/booker-action-creators';
import Keymap from '../../../../scripts/utilities/keymap';
import TranslatedCopy from '../../../intl/translated-copy';
import { normalizeString } from '../../../utilities/booker-helpers';

export default class BaseAutoCompleteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      airportsListFiltered: [],
      hasResults: false,
      highlightedIndex: -1,
      isOpen: false,
      withoutResults: false,
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSelection = this.handleSelection.bind(this);

    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentDidMount() {
    const { airportsList } = this.props;

    const airportsListFiltered = airportsList.filter( airport => airport.code === 'MAD' || airport.code === 'JFK' || airport.code === 'MTY');

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ airportsListFiltered: airportsListFiltered });
  }

  componentWillReceiveProps(nextProps) {
    const { airportsList, isActive, searchTerm } = this.props;

    if (nextProps.searchTerm && nextProps.searchTerm !== null && nextProps.searchTerm !== '' && isActive) {
      let airportsListFiltered = [];

      if (!(nextProps.searchTerm[0] === ' ' && nextProps.searchTerm[1] === ' ')) {
        const inputValue = this.removeAccents(nextProps.searchTerm);
        airportsListFiltered = airportsList.filter( airport => airport.code.includes(inputValue) || this.removeAccents(airport.city).includes(inputValue) || this.removeAccents(airport.country).includes(inputValue));
      }

      if (airportsListFiltered.length === 0 && nextProps.searchTerm !== '') {
        this.setState({ withoutResults: true });
      }

      this.setState({ airportsListFiltered: airportsListFiltered });
    }

    if (searchTerm !== nextProps.searchTerm || nextProps.searchTerm === '') {
      this.setState({ withoutResults: false });
    }

    if (searchTerm === nextProps.searchTerm && nextProps.isActive && searchTerm === '' || nextProps.searchTerm === '' ) {
      const airportsListFiltered = airportsList.filter( airport => airport.code === 'MAD' || airport.code === 'JFK' || airport.code === 'MTY');
      this.setState({ airportsListFiltered: airportsListFiltered });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    const { airportsList, searchTerm } = this.props;

    const {
      airportsListFiltered,
      highlightedIndex,
      isOpen,
      withoutResults,
    } = this.state;

    const listClasses = cx({
      'Autocomplete-listWrapper': true,
      'isOpen': isOpen,
    });

    return (
      <div className={ listClasses }  ref={ (ref) => this.listWrapperDOM = ReactDOM.findDOMNode(ref) }>
        <ul className='Autocomplete-items'>
          { !withoutResults && airportsListFiltered.length > 0 ?
            airportsListFiltered.map((item, i) => {
              const classes = cx({
                'AirportAutocompleteListItem' : true,
                'AirportAutocompleteListItem--search' : true,
                'AirportAutocompleteListItem--nearby' : false,
                'AirportAutocompleteListItem--highlighted': i === highlightedIndex,
              });

              const label = `${item.city} ${item.code}, ${item.country}`;

              return (
                <li key={ i }>
                  <button
                    className={ classes }
                    onMouseDown={ (e) => this.changeAirport(e, item) }
                    tabIndex={ airportsList ? 0 : -1 }
                  >
                    <span className='AirportAutocompleteListItem--search'>
                      { searchTerm ? this.highlightTerm(label) : label }
                    </span>
                  </button>
                </li>
              );
            })
            :
            <div className='AirportAutocompleteListItem-notFoundWrapper'>
              <h4 className='AirportAutocompleteListItem-notFoundTitle'>
                <TranslatedCopy copyID='MYB_QB_NOT_FOUND' />
              </h4>
            </div>
          }
        </ul>
      </div>
    );
  }

  changeAirport(e, airport) {
    const {
      airportsList,
      dispatch,
      type,
    } = this.props;

    if (type === 'origin') {
      const newAirportsList = airportsList.filter(item => item.code !== airport.code);
      dispatch(BookerActions.changeAirportsListFiltered(newAirportsList));
      dispatch(BookerActions.changeOriginAirport(airport));
    } else {
      dispatch(BookerActions.changeDestinationAirport(airport));
    }
  }

  fixListScroll() {
    const wrapper = this.listWrapperDOM;
    const highlighted = wrapper.querySelectorAll('button[class$=highlighted]')[0];

    if (highlighted) {
      const offsetTop = highlighted.offsetTop;

      wrapper.scrollTop = offsetTop;
    }
  }

  handleCloseList() {
    window.removeEventListener('keydown', this.handleKeyDown);
    this.setState({
      isOpen: false,
      highlightedIndex: -1,
    });
  }

  handleKeyDown(e) {
    const { highlightedIndex, airportsListFiltered } = this.state;

    if (e.keyCode === Keymap.UP) {
      e.preventDefault();
      if (highlightedIndex > 0) {
        this.setState({
          highlightedIndex: highlightedIndex - 1,
        });
        this.fixListScroll();
      }
    } else if (e.keyCode === Keymap.DOWN) {
      e.preventDefault();
      if (highlightedIndex < airportsListFiltered.length - 1) {
        this.setState({
          highlightedIndex: highlightedIndex + 1,
        });

        this.fixListScroll();
      }
    } else if (e.keyCode === Keymap.ENTER || e.keyCode === Keymap.RETURN || e.keyCode === Keymap.RIGHT || e.keyCode === Keymap.TAB) {
      e.preventDefault();
      this.handleSelection(e);
    } else if (e.keyCode === Keymap.ESCAPE) {
      e.preventDefault();
      this.handleCloseList();
    }
  }

  handleSelection(e) {
    const { airportsListFiltered, highlightedIndex } = this.state;

    if (highlightedIndex !== -1) {
      this.changeAirport(e, airportsListFiltered[highlightedIndex]);
    } else if (airportsListFiltered && airportsListFiltered.length > 0) {
      this.changeAirport(e, airportsListFiltered[0]);
    }

    document.activeElement.blur();
    this.handleCloseList();
  }

  highlightTerm(string) {
    const { searchTerm } = this.props;
    const normalizedTerm = normalizeString(searchTerm ? searchTerm : '').toLowerCase();
    const normalizedString = normalizeString(string).toLowerCase();
    let startIndex = normalizedString.indexOf(normalizedTerm);

    // nothing to highlight.
    if (startIndex < 0 ) {
      return (
        <span className='AirportAutocompleteListItem--alias'>
          { string }
        </span>);
    } else if ( searchTerm.length > 0 ) {
      const indices = [];

      while (startIndex != -1 ) {
        indices.push(startIndex);
        startIndex = normalizedString.indexOf(normalizedTerm, startIndex + 1);
      }

      const strings = [];
      let key = 0;

      for (let i = 0; i < indices.length; i++) {
        const index = indices[i];
        const lastIndex = i > 0 ? indices[ i - 1 ] + searchTerm.length : 0;
        const pre = string.substr(lastIndex, index - lastIndex);
        const highlighted = string.substr(index, searchTerm.length);

        strings.push(
          <span key={ key++ }>{pre}</span>,
          <span className='AirportAutocompleteListItem-textFound' key={ key++ }>{ highlighted }</span>
        );
      }

      const pos = string.substr(indices[indices.length - 1] + searchTerm.length, string.length - indices[indices.length - 1]);
      strings.push(<span key={ key++ }>{pos}</span>);

      return (
        <span>
          { strings }
        </span>
      );
    } else {
      return (<span>{ string }</span>);
    }
  }

  removeAccents = (str) => {
    if (str !== null) {
      return str.normalize('NFD').replace(/[\u0300-\u036f-\s+]/g, '').toUpperCase();
    }
  }

  resetListScroll() {
    const wrapper = this.listWrapperDOM;
    wrapper.scrollTop = 0;
  }
}
